module.exports = __webpack_public_path__ + "components/weather-icon/static/nightcloud-1fc0b9f8833adddfcf01fae41ab4873f.png";